module.exports = __webpack_public_path__ + "static/img/p2b-2.227a8f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/p2b-2.jpg
// module id = Bgsc
// module chunks = 1